"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Authors = _interopRequireDefault(require("./Authors"));
var _styles = require("@material-ui/core/styles");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      '& .ms-aem-reference-el--title': {
        fontStyle: 'italic'
      }
    },
    link: {
      wordBreak: 'break-all'
    }
  };
});

// TODO: remove TSX for now, will refactor later
//
// interface Author {
//   firstName?: string
//   lastName?: string
//   middleInitial?: string
// }

// interface Props {
//   type: string
//   authors: Author[]
//   year: string
//   title: string
//   publicationPlace?: string
//   publisher?: string
//   publishDate?: Date
//   dateAccessed?: Date
//   url: string
// }

var Web = function Web(props) {
  var authors = props.authors,
    year = props.year,
    title = props.title,
    publisher = props.publisher,
    publicationPlace = props.publicationPlace,
    publishDate = props.publishDate,
    dateAccessed = props.dateAccessed,
    url = props.url;
  var styles = useStyles();
  var getAllDates = '';
  if (publishDate !== undefined && dateAccessed !== undefined) {
    getAllDates = "[updated ".concat(publishDate, "; cited ").concat(dateAccessed, "].");
  } else if (publishDate !== undefined) {
    getAllDates = "[updated ".concat(publishDate, "].");
  } else if (dateAccessed !== undefined) {
    getAllDates = "[cited ".concat(dateAccessed, "].");
  } else {
    getAllDates = null;
  }
  return __jsx("div", {
    className: "ms-aem-reference-type ms-aem-reference-type--web ".concat(styles.root)
  }, authors.length > 0 && __jsx(_Authors.default, {
    authors: authors
  }), year && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: " ".concat(year, ".")
    }
  }), title && __jsx("span", null, __jsx("span", {
    className: "ms-aem-reference-el--title",
    dangerouslySetInnerHTML: {
      __html: " ".concat(title, ".")
    }
  }), __jsx("span", null, " [Internet].")), publicationPlace && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: " ".concat(publicationPlace, ":")
    }
  }), publisher && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: " ".concat(publisher, ".")
    }
  }), getAllDates && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(getAllDates)
    }
  }), url && __jsx("span", null, ' ', "Available from:", ' ', __jsx("a", {
    href: url,
    className: styles.link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, url)));
};
var _default = Web;
exports.default = _default;